import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import ID from '../../../types/id';
import { IndicatorState } from '../../consent-requests/consent-requests.component';
import { Subscription } from 'rxjs';
import {
  ApprovalTableItem,
  InvestorApprovalTableItem,
} from '../consent-approvals.component';
import Permission from '../../../interfaces/permission';
import ConsentRequiredStatus from '../../../interfaces/consent-required-status';
import ConsentApprovalStatus from '../../../interfaces/consent-approval-status';
import { MatDialog } from '@angular/material/dialog';
import { IndividualApprovalsDialogComponent } from '../individual-approvals-dialog/individual-approvals-dialog.component';

@Component({
    selector: 'approvals-table',
    templateUrl: './approvals-table.component.html',
    styleUrls: ['./approvals-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ApprovalsTableComponent {
  @Input() consent_request_id: ID;
  public columns = [
    'indicator',
    'fund',
    'consent_required',
    'sent_date',
    'percent_required',
    'current_percent',
    'fund_approval_date',
    'expander',
  ];
  public subTable = ['investor_report_comment'];
  public subTable1 = ['investor_approvals'];
  public IndicatorState = IndicatorState;

  private sub: Subscription;
  @Input() permission: Permission | null;
  @Input() readOnly: boolean = true;
  @Input() statuses: ConsentRequiredStatus[];
  @Input() approvalStatuses: ConsentApprovalStatus[];
  @Input() approvalsLoading: boolean;

  @Input() approvalItems: ApprovalTableItem[];
  @Output() approvalItemsChange = new EventEmitter<ApprovalTableItem[]>();

  @Output() updatedItems = new EventEmitter<boolean>(false);
  constructor(public dialog: MatDialog) {}

  public openApprovalDialog(consent_request_id: ID) {
    let sub = this.dialog
      .open(IndividualApprovalsDialogComponent, {
        data: { consent_request_id },
        width: '100vw',
        maxWidth: '100vw',
        height: '100vh',
      })
      .afterClosed()
      .subscribe((data) => {
        this.updatedItems.emit(true);
      });
  }
  ngOnInit() {}

  approvalRequiredChange(event: ConsentRequiredStatus, item: ApprovalTableItem) {
    if( ['CREA Approved - Consent Manager','CREA Approved - Managing Director of AM','CREA Approved - Investor Relations'].find((status) => status === event.required_status)){
      let approvalStatus = this.approvalStatuses.find((status)=> status.status === event.required_status) ?? null;
      for (let i = 0; i< item.investorApprovals.length; i++){
        item.investorApprovals[i].approval_status = approvalStatus;
      }
      this.approvalItemsChange.emit(this.approvalItems);
    }
  }
}
